module.exports = __webpack_public_path__ + "static/media/camillo-profile-pic.bccb3254.jpg";